import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import '@splidejs/splide/css/core';

const imageGalleries = document.querySelectorAll('[data-gs1-image-gallery]');

if (imageGalleries) {
  imageGalleries.forEach((imageGallery) => {
    new Splide(imageGallery, {
      autoplay: true,
      autoHeight: true,
      autoWidth: false,
      arrows: true,
      clones: 0,
      gap: '1.25rem',
      interval: 20_000,
      keyboard: true,
      lazyLoad: 'nearby',
      pagination: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      perMove: 1,
      perPage: 1,
      reducedMotion: {
        autoplay: false,
      },
      resetProgress: false,
      rewind: true,
      rewindSpeed: 500,
      type: 'loop',
      speed: 500,
    }).mount();
  });
}
